import React, { type ReactElement, useState } from 'react';
import { faRecycle } from '@fortawesome/free-solid-svg-icons';
import TableActions from 'atom-components/table-actions-lite';
import MarkingGroupPolicy from 'policies/marking-group.policy';
import { usePageAccess } from 'services/providers/page-access.provider';
import ConfirmDeleteMarkingGroupModal from './confirm-delete-marking-group-modal';

type Props = {
  markingGroupId: number;
  markingGroupName: string;
};

export default function DeleteMarkingGroupButton({
  markingGroupId,
  markingGroupName
}: Props): ReactElement {
  const [isConfirmDeleteMarkingGroupModalOpen, setIsConfirmDeleteMarkingGroupModalOpen] =
    useState<boolean>(false);

  const { authorisableUser } = usePageAccess();

  return (
    <>
      <ConfirmDeleteMarkingGroupModal
        isOpen={isConfirmDeleteMarkingGroupModalOpen}
        onClose={(): void => setIsConfirmDeleteMarkingGroupModalOpen(false)}
        markingGroupId={markingGroupId}
        markingGroupName={markingGroupName}
      />
      {MarkingGroupPolicy.delete(authorisableUser) && (
        <TableActions.Button
          tooltip="Delete Marking Group"
          onClick={(): void => setIsConfirmDeleteMarkingGroupModalOpen(true)}
          icon={faRecycle}
          disabled={!MarkingGroupPolicy.delete(authorisableUser)}
          isDangerous
        />
      )}
    </>
  );
}
